module.exports = __webpack_public_path__ + "static/media/placeText.b2cf2e76.gif";